import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlternateContact, toAlternateContacts } from '../contact-alternative-info/contact-alternative-info.model';
import { leadNeedsAlternateEntry } from './linked-contact-match.util';

/**
 * Card on the lead page showing the contact the lead is linked to, plus the people sharing that
 * record. Lets an agent on either lead (Bob's or Barbara's) see both without opening the contact.
 * For a lead linked before alternates existed, it also offers to save the lead onto the contact.
 */
@Component({
  selector: 'app-linked-contact-summary',
  templateUrl: './linked-contact-summary.component.html',
  styleUrls: ['./linked-contact-summary.component.scss'],
})
export class LinkedContactSummaryComponent {
  @Input() contact: any = null;
  /** Agent leads with a buyer show two cards, so each one names its role instead. */
  @Input() title: string = 'LINKED CONTACT';
  /** Marks the alternate entry that came from this lead. */
  @Input() leadId: string = null;
  /** The open lead; enables the "Add as Alternate Contact" prompt when it isn't on the contact yet. */
  @Input() lead: any = null;
  @Input() canEdit: boolean = false;
  @Input() isSaving: boolean = false;
  /** Emits the chosen label (null when left empty). */
  @Output() addAlternate = new EventEmitter<string>();

  selectedLabel: string = null;
  readonly labelOptions: string[] = ['Personal', 'Work', 'Home', 'Spouse', 'Partner', 'Other'];

  get contactName(): string {
    return this.contact?.full_name || `${this.contact?.first_name ?? ''} ${this.contact?.last_name ?? ''}`.trim();
  }

  get leadName(): string {
    return this.lead?.full_name || `${this.lead?.first_name ?? ''} ${this.lead?.last_name ?? ''}`.trim();
  }

  get alternateContacts(): AlternateContact[] {
    return toAlternateContacts(this.contact?.alternate_contacts);
  }

  get needsAlternateEntry(): boolean {
    return this.canEdit && leadNeedsAlternateEntry(this.lead, this.contact);
  }

  isThisLead(person: AlternateContact): boolean {
    return !!this.leadId && String(person?.lead_id ?? '') === String(this.leadId);
  }

  onAddAlternate(): void {
    this.addAlternate.emit(this.selectedLabel ?? null);
  }

  addCustomLabel = (label: string) => label;

  trackByIndex(index: number): number {
    return index;
  }
}
